import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

/*

appAuth is the authentication module for requests 
that do not require user authentication within the application

*/

export const state = {
  appSession: getSavedState('appAuth.appSession'),
  companyInfo: getSavedState('appAuth.companyInfo')
}

export const mutations = {
  SET_APP_SESSION(state, newValue) {
    state.appSession = newValue
    saveState('appAuth.appSession', newValue)
  },
  SET_COMPANY_INFO(state, newValue) {
    state.companyInfo = newValue
    saveState('appAuth.companyInfo', newValue)
  }
}

export const getters = {
  // Whether the user is currently logged in.
  appLoggedIn(state) {
    return !!state.appSession
  },
  companyInfoExists(state) {
    return !!state.companyInfo
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    dispatch('validateAppSession')
    dispatch('updateCompanyInfo')
  },

  // Logs in the current user.
  appLogIn({ commit, dispatch, getters }) {
    if (getters.appLoggedIn) return dispatch('validateAppSession')
    return axios
      .post(`${serverUrl}/api-auth/`, { 
        'username': getSecret('APP_API_USERNAME'), 
        'password': getSecret('APP_API_PASSWORD')
      })
      .then((response) => {
        const user = response.data
        commit('SET_APP_SESSION', user)
        dispatch('updateCompanyInfo', true)
        return user
      })
      .catch(() => {
        commit('SET_APP_SESSION', null)
        return null
      })
  },

  // Validates the current app's token and refreshes it
  // with new data from the API.
  updateCompanyInfo({ commit, state, getters }, force) {
    if (!getters.appLoggedIn || (getters.companyInfoExists && !force)) return Promise.resolve(null)
    commit('SET_COMPANY_INFO', null)
    return axios
      .get(`${serverUrl}/base/company-info/`, { 'appRequest': true })
      .then((response) => {
        const results = response.data.results
        if (results.length){
          const compInfo = results[results.length - 1]
          commit('SET_COMPANY_INFO', compInfo)
          return compInfo
        }
        return null
      })
      .catch(() => {
        commit('SET_COMPANY_INFO', null)
        return null
      })
  },

  validateAppSession({ commit, dispatch, getters }) {
    if (!getters.appLoggedIn) return Promise.resolve(null)
    let parsedDatetime = new Date( Date.parse(state.appSession.expires) )
    let actualDatetime = new Date()
    let datetimesDiff = parsedDatetime - actualDatetime
    if ((datetimesDiff / (1000 * 60)) < 5 && (datetimesDiff / (1000 * 60)) > 0){
      return axios
      .post(`${serverUrl}/api-auth/token-refresh/`,
        { 'token': state.appSession.key },
        { 'appRequest': true })
      .then((response) => {
        const user = response.data
        commit('SET_APP_SESSION', user)
        dispatch('updateCompanyInfo', true)
        return user
      })
      .catch(() => {
        commit('SET_APP_SESSION', null)
        return null
      })
    }else if((datetimesDiff / (1000 * 60)) <= 0){
      commit('SET_APP_SESSION', null)
    return null
    }else{
      return state.appSession.user
    }
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}